import { Injectable } from "@angular/core";
import { LayoutConfig } from "../models/layout.model";
import { signal, computed, Signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LayoutStateService {
  private layoutsSignal = signal<Map<string, LayoutConfig>>(
    new Map<string, LayoutConfig>()
  );

  public readonly allLayouts = computed(() =>
    Array.from(this.layoutsSignal().values())
  );

  constructor() {
    console.log("[LayoutState] Service initialized");
  }

  addLayout(id: string, config: LayoutConfig) {
    console.log(`[LayoutState] Adding layout ${id} to state`);
    const updatedLayouts = new Map(this.layoutsSignal());
    updatedLayouts.set(id, config);
    this.layoutsSignal.set(updatedLayouts);
  }

  deleteLayout(id: string) {
    console.log(`[LayoutState] Deleting layout ${id} from state`);
    const updatedLayouts = new Map(this.layoutsSignal());
    updatedLayouts.delete(id);
    this.layoutsSignal.set(updatedLayouts);
  }

  updateLayout(id: string, updates: Partial<LayoutConfig>) {
    console.log(`[LayoutState] Updating layout ${id} in state`);
    const layouts = this.layoutsSignal();
    const current = layouts.get(id);

    if (current) {
      const updated = { ...current, ...updates };
      const updatedLayouts = new Map(layouts);
      updatedLayouts.set(id, updated);
      this.layoutsSignal.set(updatedLayouts);
    }
  }

  getLayout(id: string): LayoutConfig | undefined {
    return this.layoutsSignal().get(id);
  }

  getAllLayouts(): Map<string, LayoutConfig> {
    return this.layoutsSignal();
  }

  getLayoutSignal(id: string): Signal<LayoutConfig | undefined> {
    return computed(() => this.layoutsSignal().get(id));
  }

  clearAllLayouts(): void {
    console.log(`[LayoutState] Clearing all layouts from state`);
    this.layoutsSignal.set(new Map<string, LayoutConfig>());
  }
} 